import {
  mediaHelper,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PropertySearch } from './PropertySearch';

const ContentWrapper = styled.div`
  margin: auto;
  max-width: 850px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: ${spacingHelper('0 medium')};

  ${mediaHelper('tabletMin')} {
    padding: ${spacingHelper('0 extraLarge')};
  }

  ${mediaHelper('desktopMin')} {
    padding: ${spacingHelper('0 0 medium 0')};
  }
`;

const Tagline = styled.h1`
  text-align: center;
  ${typographyHelper('title02')}
  color: ${paletteHelper('textInverted')};
  width: 100%;
  margin-bottom: ${spacingHelper('twoExtraLarge')};

  ${mediaHelper('tabletMin')} {
    ${typographyHelper('title01')};
  }
`;

export const PropertySearchSection: FunctionComponent<{ className?: string }> = ({ className }) => {
  return (
    <ContentWrapper className={className}>
      <Tagline>Research any property</Tagline>
      <PropertySearch />
    </ContentWrapper>
  );
};
